var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWrkStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_750_7255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4558 0H10.5442L0 10.5442V25.4558L10.5442 36H25.4558L36 25.4558V10.5442L25.4558 0Z",
    fill: "#FF2147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7587 34.3167H11.2417L1.68359 24.7585V11.2413L11.2417 1.68359H24.7587L34.3169 11.2415V24.7585L24.7587 34.3167ZM11.6157 33.4138H24.3848L33.4141 24.3845V11.6153L24.3848 2.58619H11.6157L2.58643 11.6153V24.3843L11.6157 33.4136V33.4138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7602 23.7874C24.7602 26.1807 22.8132 28.1277 20.4199 28.1277H17.1502C15.5106 28.1277 14.029 27.2206 13.2839 25.7606C13.2827 25.758 13.2813 25.7557 13.2799 25.7531L8.95624 17.752C8.71958 17.2639 8.87704 16.6722 9.32529 16.3723C9.49963 16.2544 9.70466 16.1921 9.91836 16.1921C10.3099 16.1921 10.6593 16.3922 10.8531 16.7275C10.8559 16.7322 10.8587 16.7369 10.8615 16.7416L13.2429 20.4633C13.3296 20.5987 13.4953 20.6604 13.6492 20.6156C13.8034 20.5706 13.9093 20.4291 13.9093 20.2686V10.7669C13.9093 10.1687 14.3962 9.68176 14.9944 9.68176C15.2822 9.68176 15.5554 9.79494 15.7604 9.99716C15.9662 10.2057 16.0796 10.4792 16.0796 10.7667V18.7237C16.0796 18.9233 16.2415 19.0855 16.4411 19.0855C16.6408 19.0855 16.8027 18.9236 16.8027 18.7237V8.95818C16.8027 8.35996 17.2896 7.87305 17.8878 7.87305C18.1756 7.87305 18.4488 7.98622 18.6538 8.18844C18.8595 8.39699 18.9727 8.6702 18.9727 8.95795V18.7235C18.9727 18.9231 19.1346 19.0853 19.3343 19.0853C19.5339 19.0853 19.6958 18.9233 19.6958 18.7235V10.7664C19.6958 10.1682 20.1825 9.68129 20.781 9.68129C21.0687 9.68129 21.3419 9.79447 21.547 9.99669C21.7527 10.2052 21.8661 10.4787 21.8661 10.7662V18.7232C21.8661 18.9229 22.028 19.085 22.2277 19.085C22.4273 19.085 22.5892 18.9231 22.5892 18.7232V12.9362C22.5892 12.338 23.0759 11.8511 23.6744 11.8511C23.9621 11.8511 24.2353 11.9643 24.4406 12.1665C24.6463 12.375 24.7595 12.6483 24.7595 12.936V23.7867L24.7602 23.7874Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_750_7255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWrkStop);
export default __webpack_public_path__ + "static/media/icon-wrk-stop.b6c30b67468aa713cba4d20bbaa9b5c0.svg";
export { ForwardRef as ReactComponent };